import Cookies from 'universal-cookie';
let cookie = new Cookies();

export const getCookie = () => {
	return cookie.get('appview') ? true : false

} 

export const getUid = () => {
	let Uid =  cookie.get('appview');
	return Uid.UID;
}

export const authProductCookie = (type, pID) => {
	let flag = false;

	if(!cookie.get('pview')){
		return flag;
	}
	let oldCookie = cookie.get('pview');
	let products = JSON.parse(oldCookie.products);
	
	products.forEach(p => {
		if(p.type === type && p.pID === pID){
			flag = true;
		}
	});
	
	return flag;
}
